/**
 * PlanGate — kept as a backwards-compat alias for the legacy import
 * path. New callers should import `<PlanLock>` from "./PlanLock"
 * directly. Internally this is just the `variant="page"` PlanLock
 * shape with the prior `features` prop name preserved.
 */
import { PlanLock, type RequiredPlan } from "./PlanLock";

export { planMeets, PLAN_ORDER, PLAN_NAMES } from "./PlanLock";
export type { RequiredPlan };

interface PlanGateProps {
  requiredPlan: RequiredPlan;
  featureName: string;
  features: string[];
}

export function PlanGate({ requiredPlan, featureName, features }: PlanGateProps) {
  return (
    <PlanLock
      variant="page"
      requiredPlan={requiredPlan}
      featureName={featureName}
      features={features}
    />
  );
}
